import styled from 'styled-components'

interface IStyleProps {
  disabled?: boolean
}

export const Input = styled.input`
  &&[type='checkbox'] {
    position: absolute;
    left: -9999px;
  }
  &&[type='checkbox'] + label {
    background: url(https://adm.attogroup.com.br/icons/checkbox.svg) 0 0
      no-repeat;
    padding-left: 40px;
    height: 28px;
    filter: grayscale(${({ disabled }: IStyleProps) => (disabled ? 1 : 1)});
    pointer-events: ${({ disabled }: IStyleProps) =>
      disabled ? 'none' : 'auto'};
  }
  &&[type='checkbox']:checked + label {
    background-position: 0 -28px;
  }
`

export const Label = styled.label`
  color: var(--Cinza-Cinza---75, #757575);
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  display: flex;
  align-items: center;
`

export const Div = styled.div<IStyleProps>`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 16px;
  cursor: pointer;

  .loading-img-button {
    width: 28px;
    height: 28px;
    top: 20px;
    right: 20px;
    animation: load 2s infinite linear;
  }
`
